<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!--      <b><p>{{ currentUser.merchant_name }}</p></b>-->
      <table>
        <tr style="text-align:center">
          <b>{{ `${currentUser ? currentUser.first_name : ''} ${currentUser ? currentUser.last_name : ''}` }}</b>
        </tr>
        <tr><b>{{ form.company_name }}</b></tr>
      </table>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ currentUser ? currentUser.first_name : '' }} {{ currentUser ? currentUser.last_name : '' }}
            </p>
            <span class="user-status">{{ currentUser ? currentUser.user_name : '' }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/4-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          to="business-settings"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="onClickLogout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import {
  mapGetters,
  mapActions,
} from 'vuex'

const ResourceRepository = RepositoryFactory.get('businessSettings')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      merchant: '',
      form: {},
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  mounted() {
    this.fetchBusinessDetailList()
  },
  methods: {
    ...mapActions(['logout']),
    async onClickLogout() {
      await this.logout()
    },
    async fetchBusinessDetailList() {
      try {
        const { data } = (await ResourceRepository.getBusinessSettigs()).data
        this.form = data
      } catch (e) {
        this.showErrorMessage(e)
      }
      this.loading = false
    },
  },
}
</script>
